import React from 'react';
import { table } from '@/shared/theme/tokens';
import Box from '../primitives/Box';

export interface FilterableCellProps {
  filterable?: boolean;
  active?: boolean;
  /** Stretch across the table cell so a click on the cell filters, not the row. */
  fill?: boolean;
  onFilter?: () => void;
  children: React.ReactNode;
}

const FilterableCell: React.FC<FilterableCellProps> = ({
  filterable = true,
  active = false,
  fill = false,
  onFilter,
  children,
}) => {
  if (!filterable) {
    return <>{children}</>;
  }

  return (
    <Box
      component="span"
      onClick={(event) => {
        event.stopPropagation();
        onFilter?.();
      }}
      sx={{
        display: fill ? 'flex' : 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        borderRadius: 1,
        px: 0.5,
        mx: -0.5,
        color: active ? 'primary.main' : 'inherit',
        fontWeight: active ? 600 : 'inherit',
        bgcolor: active ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
        '&:hover': {
          textDecoration: 'underline',
          color: 'primary.main',
        },
        ...(fill
          ? {
              width: `calc(100% + ${table.bodyPaddingX} + ${table.bodyPaddingX})`,
              minHeight: `calc(100% + ${table.bodyPaddingY} + ${table.bodyPaddingY})`,
              boxSizing: 'border-box',
              mx: `-${table.bodyPaddingX}`,
              my: `-${table.bodyPaddingY}`,
              px: table.bodyPaddingX,
              py: table.bodyPaddingY,
            }
          : {}),
      }}
    >
      {children}
    </Box>
  );
};

export default FilterableCell;
